import clsx from 'clsx'
import { computed, defineComponent, useId } from 'vue'

import type { Props as VCheckboxProps } from './VCheckbox'
import VCheckbox from './VCheckbox'
import VLabel from './VLabel'

interface Props extends VCheckboxProps {
  label: string
  reverseEnabled?: boolean
}

export default defineComponent<Props>((props) => {
  const componentId = useId()

  // #region Props Getters

  const tData = computed((): string => props.tData ?? 'v-checkbox')
  const id = computed((): string => props.id ?? componentId)

  // #endregion

  return () => (
    <div class={clsx('flex items-center', { 'flex-row': !props.reverseEnabled, 'flex-row-reverse': props.reverseEnabled })}>
      <VCheckbox
        id={id.value}
        tData={tData.value}
        class={props.class}
        size={props.size}
        color={props.color}
        value={props.value}
        indeterminateEnabled={props.indeterminateEnabled}
        disabled={props.disabled}
        onInput={props.onInput}
        onClick={props.onClick}
      />
      <VLabel
        for={id.value}
        disabled={props.disabled}
      >{props.label}
      </VLabel>
    </div>
  )
}, {
  name: 'VLabelCheckbox',
  props: ['label', 'reverseEnabled', 'id', 'class', 'tData', 'size', 'color', 'value', 'indeterminateEnabled', 'disabled', 'onInput', 'onClick']
})
